export default __webpack_public_path__ + "static/media/retvinkel-trekant.a82d4196.svg";